import React, { useEffect, useRef } from "react";

import { Flex, Text } from "@chakra-ui/react";

export const Group = ({
  mt,
  title,
  children,
  minHeight,
  border,
  scrollToField,
}) => {
  const anexoRef = useRef(null);

  useEffect(() => {
    scrollToField && scrollToField(anexoRef);
  }, [scrollToField]);

  return (
    <Flex
      mt={mt ? mt : "15px"}
      flexDir="column"
      w="100%"
      minHeight={`${minHeight}`}
      bgColor="#FFF"
      padding={{ base: "5px", sm: "15px" }}
      borderRadius="20px"
      border={border ? border : ""}
      ref={anexoRef}
    >
      <Text
        fontWeight={700}
        fontSize="16px"
        lineHeight="19.6px"
        whiteSpace="break-spaces"
        color="#169499"
      >
        {title.toUpperCase()}
      </Text>
      {children}
    </Flex>
  );
};
